import services from '../assets/js/services'
// import utils from '../assets/js/utils'
export default {
  state: {
    appsUserInfo: {}, // 登录后用户信息
    schoolInfo: null, // 学校信息
  },
  getters: {
  },
  actions: {
    // 获取用户信息
    getAppsLoginUserInfo (context, payload) {
      return services.getAppsUserInfo({ payload }).then(res => {
        if (res.code == '0000') {
          if (res.data) {
            // let urlCode = utils.getUrlSchoolCode(window.location.pathname)
            // if (res.data.school_code != urlCode) {
            //   window.open(`/${res.data.school_code}`, "_self")
            // }
            localStorage.setItem("userInfo", JSON.stringify(res.data))
            localStorage.setItem("schoolCode", res.data.school_code)
            context.commit('setAppsLoginUserInfo', {
              'userInfo': res.data ? res.data : {}
            })
            // 如果访问的是院校端,判断如果没有权限进入,跳转到用户端
            // if (window.location.href.indexOf('/school') > -1 && res.data ) {
            //   if ((res.data.user_type == 2 || (res.data.user_type == 1 && (res.data.role_ids == 1 || res.data.role_ids == 2)))) {
            //     console.log('进入到院校端')
            //   } else {
            //     window.open(`/${res.data.school_code}`, "_self")
            //   }
            // }
          }
        }
        return res;
      })
    },

    // 退出登录
    requestAppsLogout (context, payload) {
      return services.postAppsLogout({ format: "html", from: encodeURI(window.location.href), ...payload }).then(res => {
        if (res.code == '0000') {
          localStorage.removeItem("userInfo")
          localStorage.removeItem("appsToken")
          context.commit('setAppsLoginUserInfo', {
            'userInfo': {}
          })
          if (res.data && res.data.redirect) {
            window.open(`${res.data.redirect}`, '_self')
          } else {
            window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${localStorage.getItem("schoolCode")}&format=html&from=${window.location.href}`, "_self");
          }
        }
        return res;
      })
    },
    // 获取学校信息
    getLoginSchoolInfo (context, payload) {
      return services.getAppsSchoolInfo(payload).then(res => {
        if (res.code == '0000') {
          context.commit('setSchoolInfo', {
            'data': res.data ? res.data : []
          })
        }
        return res;
      })
    },
  },
  mutations: {
    setAppsLoginUserInfo (state, payload) {
      state.appsUserInfo = payload.userInfo;
    },
    setSchoolInfo (state, payload) {
      state.schoolInfo = payload.data;
    },
  }
}